import { actionTypes } from '../../actionTypes';
import * as apiRoutes from '../../apiRoutes';
import { ErrorData, APIUrl } from '../../constants';
import * as api from '../../tools/apiMiddleware';

const initialState = { isLoading: true, lists: [], hasErrorOccured: false, errorData: ErrorData };

export const actionCreators = {
    getDeletedCues: programmeId => async (dispatch, getState) => {

        let url = APIUrl + apiRoutes.DeletedCues + '/' + programmeId;
        api.getRequest(dispatch, url, actionTypes.GET_DELETED_CUES, actionTypes.GET_DELETED_CUES_SUCCESS, actionTypes.GET_DELETED_CUES_FAIL);

    },
    clearErrorMessage: () => (dispatch, getState) => {

        dispatch({ type: actionTypes.DELETED_CUES_CLEAR_ERROR });

    }
};

export const reducer = (state, action) => {
    state = state || initialState;

    switch (action.type) {
        case actionTypes.GET_DELETED_CUES:
            return {
                ...state,
                isLoading: true,
                lists: state.lists,
                hasErrorOccured: false
            };
        case actionTypes.GET_DELETED_CUES_SUCCESS:
            return {
                ...state,
                lists: action.data,
                isLoading: false,
                hasErrorOccured: false
            };
        case actionTypes.GET_DELETED_CUES_FAIL:
            return {
                ...state,
                isLoading: false,
                lists: state.lists,
                hasErrorOccured: true,
                errorData: action.data
            };
        case actionTypes.DELETED_CUES_CLEAR_ERROR:
            return {
                ...state,
                isLoading: false,
                lists: state.lists,
                hasErrorOccured: false
            };
    }

    return state;
};


// WEBPACK FOOTER //
// ./src/store/Cuesheets/DeletedCuesStore.js